<aurora-header auroraAppHeader [view]="'Work'">
    <account-search slot="main"></account-search>
    <div slot="main" class="title_bar--item title_bar--new">
        <new-business-button *sm-has-permission="TENANT_PERMISSIONS.Base_Work_Accounts_AddAccounts"></new-business-button>
    </div>
    <user-task-timer slot="actions"></user-task-timer>
    <ikc-button slot="actions" />
    <sm-notification-icon-button slot="actions"></sm-notification-icon-button>
    @if (authService.getAreaKey()) {
    <div slot="actions" class="main-menu-dropdown" (click)="$event.stopPropagation()">
        <aurora-icon-button
            id="mainMenuButton"
            class="main-menu-button"
            variant="ghost"
            size="xlarge"
            icon="more-vertical"
            label="Main menu"
            (click)="toggleMainMenu($event)">
        </aurora-icon-button>
        @if (isMainMenuOpen) {
        <div class="main-menu-dropdown-panel">
            <sm-main-menu [view]="'Work'" (itemSelected)="isMainMenuOpen = false"></sm-main-menu>
        </div>
        }
    </div>
    }
</aurora-header>

<main>
    <router-outlet></router-outlet>
    <aurora-loading-indicator *ngIf="loading" overlay></aurora-loading-indicator>
</main>
